import React, { useMemo } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { Table } from "antd";

function generateCSVData(seriesData) {
  if (seriesData.length === 0) return [];

  let csvData = [];

  const symbolSet = new Set();

  seriesData.forEach((balance) => {
    const symbolBalancePairs = balance.value.split(",");
    const balanceValues = [];
    symbolBalancePairs.forEach((symbolBalancePair) => {
      const symbol = symbolBalancePair.split(":")[0].trim();
      symbolSet.add(symbol);
      const balance = symbolBalancePair.split(":")[1].trim();
      balanceValues.push(balance);
    });
    csvData.unshift([balance.time, ...balanceValues]);
  });

  csvData.unshift(["time", ...symbolSet]);

  return csvData;
}

const AccountBalances = ({ balances }) => {
  const columns = [
    {
      title: "",
      dataIndex: "time",
      colSpan: 0,
      key: "time",
    },
    {
      title: "Account Balances",
      dataIndex: "value",
      colSpan: 2,
      width: "50%",
      key: "value",
    },
  ];

  const dataSource = useMemo(() => {
    if (!balances || !balances[0]) {
      return [];
    }
    const balanceObj = balances[0].balancesObj;
    return Object.keys(balanceObj)
      .splice(1) // Do not add the first element - it is an auxiliary used for diff
      .filter((time) => Object.keys(balanceObj[time]).length > 0) // Only display non-empty balances
      .map((e, i) => ({
        key: i + 1,
        time: e,
        value: Object.keys(balanceObj[e])
          .map((f) => f + ":" + balanceObj[e][f])
          .join(", "),
      }));
  }, [balances]);

  return (
    <>
      <CSVLink data={generateCSVData(dataSource)} filename={`accountBalances.csv`}>
        <DownloadOutlined style={{ marginRight: 5 }} />
        Download csv
      </CSVLink>
      <Table
        bordered
        scroll={{ y: 600 }}
        dataSource={dataSource?.reverse()}
        columns={columns}
        pagination={{ position: ["bottomRight"], defaultPageSize: 100 }}
      />
    </>
  );
};
export default AccountBalances;
